
import React from 'react';

const MidPageCTA: React.FC = () => {
  const scrollToForm = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-[#0F1419]">
      <div className="max-w-6xl mx-auto px-4">
        <div className="bg-[#1A4D2E] rounded-[3rem] p-8 md:p-16 text-center relative overflow-hidden shadow-2xl border-4 border-[#4E3629]/20">
          <div className="absolute top-0 right-0 p-8 opacity-10 pointer-events-none">
            <svg className="w-48 h-48 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" />
            </svg>
          </div>
          
          <div className="relative z-10">
            <h2 className="text-3xl md:text-6xl font-black text-white mb-6 uppercase tracking-tighter italic leading-none">
              Built For The Trade, By The Trade.
            </h2>
            <div className="max-w-3xl mx-auto">
              <p className="text-xl md:text-2xl font-black text-[#F4E4C1] mb-6 uppercase tracking-widest">You handle the trees. We handle the traffic.</p>
              <p className="text-lg text-white/90 leading-relaxed mb-10 font-bold italic">
                Most agencies treat tree guys like they're stupid. We don't. We know you run a serious operation. This system gives you the same firepower as the million-dollar companies, for less than the cost of a chainsaw.
              </p>
              <div className="flex flex-col items-center gap-4">
                <button 
                  onClick={scrollToForm}
                  className="bg-[#FF6B35] hover:bg-white hover:text-[#1A4D2E] text-white px-12 py-6 rounded-2xl text-xl font-black transition-all transform hover:scale-105 active:scale-95 shadow-2xl shadow-orange-900/40 uppercase tracking-tighter cursor-pointer"
                >
                  TEST DRIVE IT FOR FREE
                </button>
                <p className="text-[#FF6B35] font-black uppercase text-xs tracking-widest animate-pulse">
                  ONLY 7 SPOTS LEFT THIS MONTH
                </p>
              </div>
              <p className="mt-6 text-[#F4E4C1]/50 text-xs font-black uppercase tracking-[0.2em]">14 Days access. Full features.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTA;
